import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import CreateCancelContract from "../pages/cancelContract/CreateCalcelContract";
import UpdateParcelNumber from "../pages/cancelContract/UpdateParcelNumber";
import SendInvestigateAssestsOnline from "../pages/preInvestigateAssets/SendInvestigateAssestsOnline";
import UpdateStatusResponse from "../pages/cancelContract/UpdateStatusResponse";
import ReportResponse from "../pages/cancelContract/ReportResponse";
import CreateCancelHand from "../pages/cancelHand/CreateCancelHand";
import MainSubBeforeLawsuits from "../pages/before_filing_a_lawsuit/subs/MainSubBeforeLawsuit";
import MainInvestigatingAssetses from "../pages/before_filing_a_lawsuit/subs/MainInvestigatingAssets";
import MainHistorys from "../pages/before_filing_a_lawsuit/subs/MainHistory";
import ImportInvestigateAssestsOnline from "../pages/preInvestigateAssets/ImportInvestigateAssestsOnline";
import AssetsMain from "../pages/preInvestigateAssets/AssetsMain";
// import CreateLawsuit from "../pages/lawsuit/CreateLawsuit";
import MainCheckDocument from "../pages/preInvestigateAssets/MainCheckDocument";
import ChooseContract from "../pages/ceoManageContract/ChooseContract";
import MainAddAddressTr from "../pages/preInvestigateAssets/MainAddAddressTr";
import WithdrawAdvancePayment from "../pages/lawsuit/WithdrawAdvancePayment";
import ApproveDoc from "../pages/lawsuit/ApproveDoc";
import MainCreateLawsuit from "../pages/lawsuit/MainCreateLawsuit";
import MainManageWithdrawAdvancePayment from "../pages/manageAdvancePayment/MainManageWithdrawAdvancePayment";
import AppointmentLawsuit from "../pages/lawsuit/AppointmentLawsuit";
import MainContnoLawsuit from "../pages/ceoManageContract/MainContnoLawsuit";
import ClearAdvancePayment from "../pages/lawsuit/ClearAdvancePayment";
import MainManageClearAdvancePayment from "../pages/manageAdvancePayment/MainManageClearAdvancePayment";
import MainDocumentContno from "../pages/documentContno/MainDocumentContno";
import MainCreateJudgment from "../pages/court/MainCreateJudgment";
import Profile from "../pages/userManage/Profile";
import ChangePassword from "../pages/userManage/ChangePassword";
import MenuDashboard from "../pages/dashbord/MenuDashboard";
import MenuCancelContract from "../pages/cancelContract/MenuCancelContract";
import MenuCancelContractHand from "../pages/cancelHand/MenuCancelContractHand";
import MenuPreInvestigateAssets from "../pages/preInvestigateAssets/MenuPreInvestigateAssets";
import MenuLawsuit from "../pages/lawsuit/MenuLawsuit";
import MenuCourt from "../pages/court/MenuCourt";
import MenuManageAdvancePayment from "../pages/manageAdvancePayment/MenuManageAdvancePayment";
import MainEnforceCase from "../pages/court/MainEnforceCase";
import MainFinalCase from "../pages/court/MainFinalCase";
// import ContractDetail from "../pages/contractDetail/ContractDetail";
import ClearAdvancePaymentCourt from "../pages/court/clearPayment/ClearAdvancePayment";
import WithdrawAdvancePaymentCourt from "../pages/court/withdrawPayment/WithdrawAdvancePaymentCourt";
import Liff from "../pages/userManage/Liff";
import Loginline from "../pages/userManage/LoginLine";
import MainClosingBalance from "../pages/closingBalance/MainClosingBalance";
import ClearAdvanePay from "../pages/chargeIndict/ClearAdvanePay";
import AdvanePay from "../pages/chargeIndict/AdvanePay";
import MenuChargeIndict from "../pages/chargeIndict/MenuChargeIndict";
import DetailPayment from "../pages/contractDetail/DetailPayment";
import BillAfterCourt from "../pages/afterCourt/BillAfterCourt";
import MainAllContract from "../pages/allContract/main_all_contract";
import MainReCheckJudgement from "../pages/recheckJudgement/MainReCheckJudgement";
import MenuWorkCancelContract from "../pages/workCancelContract/MenuWorkCancelContract";
import CreateCancelContractNew from "../pages/workCancelContract/CreateCancelContract";
import MainReportPayment from "../pages/reportPayment/MainReportPayment";
import DemandGuarantorMains from "../pages/demandGuarantor/DemandGuarantorMain";
import MainReportAdvancePayment from "../pages/reportPayment/MainReportAdvancePayment";
import AccRecheckJudgement from "../pages/AccRecheckJudgement/MainReCheckJudgement";
import CEORecheckJudgement from "../pages/ceoRecheckJudgement/MainReCheckJudgement";
import MainPostGL from "../pages/postGL/MainPostGL";
import MainCutPay1And8 from "../pages/finaceCutPay/MainCutPay1And8";
import MainReportSelling from "../pages/reportPayment/MainReportSelling";
import MainReportSellingAndInstallments from "../pages/reportPayment/MainReportSellingAndInstallments";
import PdfUploader from "../pages/readPdf/PdfUploader";
import MainReportDebtors from "../pages/reportPayment/MainReportDebtors";
import MainPaymentInvestigate from "../pages/investigatePayment/MainPaymentInvestigate";
import MainCreatePaymentInvestigate from "../pages/investigatePayment/MainCreatePaymentInvestigate";
import DashboradLawyerJob from "../pages/dashbord/DashboradLawyerJob";
import MainReportProfitRecognition from "../pages/profitRecognitionReport/MainReportProfitRecognition";
import MainChangeLawyerJobs from "../pages/changeLawyerJobs/MainChangeLawyerJobs";
import MenuReceivePayment from "../pages/receivePayment/MenuReceivePayment";
import MainReceivePayment from "../pages/receivePayment/MainReceivePayment";
import MainCancelReceivePayment from "../pages/receivePayment/MainCancelReceivePayment";
import MainReprintReceivePayment from "../pages/receivePayment/MainReprintReceivePayment";
import FormLawsuit from "../pages/lawsuit/FormLawsuit";
import MainImpoundCar from "../pages/reportPayment/MainImpoundCar";
import MainSellingCarImpound from "../pages/documentContno/MainSellingCarImpound";
import MainSellingCar from "../pages/reportPayment/MainSellingCar";
import MainReportManagerAcc from "../pages/reportPayment/MainReportManagerAcc";
import MainRollbackJobsLawyers from "../pages/rollbackJobsLawyers/MainRollbackJobsLawyers";
import AssignInvestigateOnsite from "../pages/manageAssetOnsite/AssignInvestigateOnsite";
import MainChangeInvestor from "../pages/manageAssetOnsite/MainChangeInvestor";
import MainAcceptJobs from "../pages/manageAssetOnsite/MainAcceptJobs";
import MainSelectLocationInvestigate from "../pages/investigateOnsite/MainSelectLocationInvestigate";

import ClearAdvancePaymentInvestigate from "../pages/investigateOnsite/ClearAdvancePaymentInvestigate";
import WithdrawAdvancePaymentInvestigate from "../pages/investigateOnsite/WithdrawAdvancePaymentInvestigate";
import MainSelectEnforceAsset from "../pages/enforceAsset/MainSelectEnforceAsset";
import ClearAdvancePaymentEnforceAsset from "../pages/enforceAsset/ClearAdvancePaymentEnforceAsset";
import WithdrawAdvancePaymentEnforceAsset from "../pages/enforceAsset/WithdrawAdvancePaymentEnforceAsset";
import MainSelectAssetAnnouncement from "../pages/assetAnnouncement/MainSelectAssetAnnouncement";
import MainSelectAssetAverage from "../pages/assetAverage/MainSelectAssetAverage";
import SaleAnnouncementCalendar from "../pages/assetAnnouncement/SaleAnnouncementCalendar";
import MainLetterCalendars from "../pages/letterCalendar/MainLetterCalendar";
import MainContnoReceivePayment from "../pages/reportPayment/MainContnoReceivePayment";
import MainLostContactDebts from "../pages/dashbord/MainLostContactDebts";
import ContractDetail from "../pages/contractDetail/ContractDetailNew";
import MainLostContactJudge from "../pages/manageAssetOnsite/MainLostContactJudge";
import MainAssignInvestigatorOnsite from "../pages/manageAssetOnsite/MainAssignInvestigatorOnsite";
import SendLawyerPage from "../pages/sendLawyersAMC/SendLawyerPage";
import MainSelectToEnforce from "../pages/manageAssetOnsite/MainSelectToEnforce";
import MainLostContactDebtsAcc from "../pages/reportPayment/MainLostContactDebtsAcc";
import JudgeDocument from "../pages/contractDetail/JudgeDocument";
import MainJudgeAssets from "../pages/dashbord/MainJudgeAssets";
import MainEnforceDoc from "../pages/enforce/MainEnforceDoc";
import MainContractToEnforce from "../pages/investigateOnsite/MainContractToEnforce";
import MainOldContno from "../pages/manageOldContno/MainOldContno";
import MainInvestigationRoute from "../pages/investigateOnsite/MaininvestigationRoute";
import MainRefinaceEnforce from "../pages/refinance/MainRefinaceEnforce";
import MenuRefinance from "../pages/refinance/MenuRefinance";
import MainRejudgementEnforce from "../pages/refinance/MainRejudgementEnforce";
import SendLawyerPageV2 from "../pages/sendLawyersAMC/SendLawyerPageV2.js";
import MainPendingSellingCar from "../pages/reportPayment/MainPendingSellingCar.js";
import MainContractToFieldCollection from "../pages/fieldCollection/MainContractToFieldCollection.js";
import MenuEnforce from "../pages/enforce/MenuEnforce.js";
import MainFieldCollectionDoc from "../pages/enforce/MainFieldCollectionDoc.js";
import ContractDetailMeeting from "../pages/contractDetail/ContractDetailMeeting.js";
import EnforceReport from "../pages/reportSummaryJobsEnforce/EnforceReport.js";
import MainReportIncomeStock from "../pages/reportPayment/MainReportIncomeStock.js";
import ContractDetailNew from "../pages/contractDetailNew/ContractDetailNew";
import DashboradLawyerJobReceiv from "../pages/dashbord/DashboradLawyerJobReceiv.js";
import MainSent90CEOToS4 from "../pages/Sent90ToCEOS3/MainSent90CEOToS4";

export default function Router({ onMenuClick }) {
  return (
    <>
      <AnimatePresence mode="wait">
        <Routes>
          <Route
            path="/chang-password"
            element={<ChangePassword onClick={onMenuClick} />}
          />
          <Route path="/profile" element={<Profile onClick={onMenuClick} />} />
          <Route path="/liff" element={<Liff />} />
          <Route path="/login-line" element={<Loginline />} />
          {/* ย้ายมาจากอันเก่า */}
          {/* ขอปิดยอดเบน */}
          <Route
            path="finance/closing-balance/request-closing-balance"
            element={<MainClosingBalance />}
          />
          <Route
            path="/menu-manage-advance-payment/legal-execution"
            element={<MenuChargeIndict />}
          />
          <Route
            path="/finance/charge-indict/advane-pay"
            element={<AdvanePay />}
          />
          <Route
            path="/finance/charge-indict/clear-advane-pay"
            element={<ClearAdvanePay />}
          />
          <Route
            path="/contract-detail/detail-payment"
            element={<DetailPayment />}
          />
          {/*---- menu-start ----*/}
          <Route path="/" element={<MenuDashboard onClick={onMenuClick} />} />
          {/* <Route
            path="/search/contarct-detail"
            element={<ContractDetail onClick={onMenuClick} />}
          /> */}
          <Route
            path="/search/contarct-detail"
            element={<ContractDetail onClick={onMenuClick} />}
          />
          <Route
            path="/menu-cancel-contrat"
            element={<MenuCancelContract onClick={onMenuClick} />}
          />
          <Route
            path="/menu-cancel-contrat-hand"
            element={<MenuCancelContractHand onClick={onMenuClick} />}
          />
          <Route
            path="/menu-pre-investigate-assets"
            element={<MenuPreInvestigateAssets onClick={onMenuClick} />}
          />
          <Route
            path="/menu-lawsuit"
            element={<MenuLawsuit onClick={onMenuClick} />}
          />
          <Route
            path="/menu-court"
            element={<MenuCourt onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-advance-payment/lawsuit"
            element={<MenuManageAdvancePayment onClick={onMenuClick} />}
          />
          {/*---- menu-end ----*/}
          <Route
            path="cancel-contract/create-cancel-Contract"
            element={<CreateCancelContract onClick={onMenuClick} />}
          />
          <Route
            path="cancel-contract/update-parcel-number"
            element={<UpdateParcelNumber onClick={onMenuClick} />}
          />
          <Route
            path="cancel-contract/update-status-response"
            element={<UpdateStatusResponse onClick={onMenuClick} />}
          />
          <Route
            path="cancel-contract/report-response"
            element={<ReportResponse onClick={onMenuClick} />}
          />
          <Route
            path="manage-contract/choose-contract"
            element={<ChooseContract onClick={onMenuClick} />}
          />
          <Route
            path="pre-investigate-assets/send-investigate-assets-online"
            element={<SendInvestigateAssestsOnline onClick={onMenuClick} />}
          />
          <Route
            path="pre-investigate-assets/import-investigate-assets-online"
            element={<ImportInvestigateAssestsOnline onClick={onMenuClick} />}
          />
          <Route
            path="pre-investigate-assets/main-assets-online"
            element={<AssetsMain onClick={onMenuClick} />}
          />
          <Route
            path="cancel-hand/create-cancel-hand"
            element={<CreateCancelHand onClick={onMenuClick} />}
          />
          <Route
            path="before-investigate-assets/visit-area"
            element={<MainSubBeforeLawsuits onClick={onMenuClick} />}
          />
          <Route
            path="before-investigate-assets/add-assests"
            element={<MainInvestigatingAssetses onClick={onMenuClick} />}
          />
          <Route
            path="before-investigate-assets/history"
            element={<MainHistorys onClick={onMenuClick} />}
          />
          <Route
            path="pre-investigate-assets/check-document"
            element={<MainCheckDocument onClick={onMenuClick} />}
          />
          <Route
            path="lawsuit/approve-doc"
            element={<ApproveDoc onClick={onMenuClick} />}
          />
          <Route
            path="lawsuit/create-lawsuit"
            element={<MainCreateLawsuit onClick={onMenuClick} />}
          />
          <Route
            path="lawsuit/appointment-court"
            element={<AppointmentLawsuit onClick={onMenuClick} />}
          />
          <Route
            path="pre-investigate-assets/import_addressTr"
            element={<MainAddAddressTr onClick={onMenuClick} />}
          />
          <Route
            path="lawsuit/withdraw-advance-payment-lawsuit"
            element={<WithdrawAdvancePayment onClick={onMenuClick} />}
          />
          <Route
            path="finance/advance-payment-lawsuit/aprove-withdraw-advance-payment"
            element={<MainManageWithdrawAdvancePayment onClick={onMenuClick} />}
          />
          <Route
            path="finance/advance-payment-lawsuit/aprove-clear-advance-payment"
            element={<MainManageClearAdvancePayment onClick={onMenuClick} />}
          />
          <Route
            path="manage-contract/main-contno-lawsuit"
            element={<MainContnoLawsuit onClick={onMenuClick} />}
          />
          <Route
            path="lawsuit/clear-advance-payment-lawsuit"
            element={<ClearAdvancePayment onClick={onMenuClick} />}
          />
          <Route
            path="document-contno/check-document-contno"
            element={<MainDocumentContno onClick={onMenuClick} />}
          />
          <Route
            path="court/create-judgment"
            element={<MainCreateJudgment onClick={onMenuClick} />}
          />
          <Route
            path="court/enforce-case"
            element={<MainEnforceCase onClick={onMenuClick} />}
          />
          <Route
            path="court/final-judgment-or-appeal"
            element={<MainFinalCase onClick={onMenuClick} />}
          />
          <Route
            path="/court/withdraw-advance-payment-court"
            element={<WithdrawAdvancePaymentCourt onClick={onMenuClick} />}
          />
          <Route
            path="/court/clear-advance-payment-court"
            element={<ClearAdvancePaymentCourt onClick={onMenuClick} />}
          />
          <Route
            path="/old-data-check/bill-after-court"
            element={<BillAfterCourt onClick={onMenuClick} />}
          />
          <Route path="/main-all-contract" element={<MainAllContract />} />
          <Route
            path="/after-court/recheck-judgement"
            element={<MainReCheckJudgement onClick={onMenuClick} />}
          />
          {/* ออกบอกเลิกใหม่ */}
          <Route
            path="/menu-work-cancel-contrat"
            element={<MenuWorkCancelContract onClick={onMenuClick} />}
          />
          <Route
            path="menu-work-cancel-contrat/create-cancel-contract"
            element={<CreateCancelContractNew onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-finance/report-payment"
            element={<MainReportPayment onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-advance-payment/report-advance-payment"
            element={<MainReportAdvancePayment onClick={onMenuClick} />}
          />
          {/* ออกบอกเลิกใหม่ */}
          {/*ออกบอกกล่าว*/}
          <Route
            path="/demand-guarantor/create-demand-guarantor"
            element={<DemandGuarantorMains onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/acc-recheck-judgement"
            element={<AccRecheckJudgement onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/post-gl"
            element={<MainPostGL onClick={onMenuClick} />}
          />
          <Route
            path="/manage-contract/ceo-recheck-judgement"
            element={<CEORecheckJudgement onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-finance/finance-cut-pay"
            element={<MainCutPay1And8 onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/report-selling"
            element={<MainReportSelling onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/report-selling-and-installments"
            element={<MainReportSellingAndInstallments onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/report-debtors"
            element={<MainReportDebtors onClick={onMenuClick} />}
          />
          <Route
            path="/read-pdf"
            element={<PdfUploader onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-finance/main-investigate-payment"
            element={<MainPaymentInvestigate onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/create-investigate-payment"
            element={<MainCreatePaymentInvestigate onClick={onMenuClick} />}
          />
          <Route
            path="/manage-contract/dashborad-lawyer-job"
            element={<DashboradLawyerJob onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/report-profit-recognition"
            element={<MainReportProfitRecognition onClick={onMenuClick} />}
          />
          <Route
            path="/manage-contract/change-lawyer-jobs"
            element={<MainChangeLawyerJobs onClick={onMenuClick} />}
          />

          <Route
            path="/menu-manage-finance/menu-receive-payment"
            element={<MenuReceivePayment onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-finance/main-receive-payment"
            element={<MainReceivePayment onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-finance/main-cancel-receive-payment"
            element={<MainCancelReceivePayment onClick={onMenuClick} />}
          />

          <Route
            path="/menu-manage-finance/main-reprint-receive-payment"
            element={<MainReprintReceivePayment onClick={onMenuClick} />}
          />
          <Route
            path="/lawsuit/form-lawsuit"
            element={<FormLawsuit onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/report-impound-car"
            element={<MainImpoundCar onClick={onMenuClick} />}
          />

          <Route
            path="/document-contno/selling-car-impound"
            element={<MainSellingCarImpound onClick={onMenuClick} />}
          />
          <Route
            path="/menu-acc/report-selling-car"
            element={<MainSellingCar onClick={onMenuClick} />}
          />

          <Route
            path="/menu-acc/report-manager-acc"
            element={<MainReportManagerAcc onClick={onMenuClick} />}
          />

          <Route
            path="/manage-contract/rollback-jobs-lawyers"
            element={<MainRollbackJobsLawyers onClick={onMenuClick} />}
          />

          {/* เริ่มบังคับคดี */}
          <Route
            path="/enforce-investigate/assign-investigate-onsite"
            element={<AssignInvestigateOnsite onClick={onMenuClick} />}
          />

          <Route
            path="/enforce-investigate/main-change-investor"
            element={<MainChangeInvestor onClick={onMenuClick} />}
          />
          <Route
            path="/enforce-investigate/main-accept-jobs"
            element={<MainAcceptJobs onClick={onMenuClick} />}
          />

          <Route
            path="/enforce-investigate/main-select-location-investigagte"
            element={<MainSelectLocationInvestigate onClick={onMenuClick} />}
          />

          <Route
            path="/enforce-investigate/main-investigate-route"
            element={<MainInvestigationRoute onClick={onMenuClick} />}
          />
          <Route
            path="/enforce-investigate/withdraw-advance-payment-onsite"
            element={
              <WithdrawAdvancePaymentInvestigate onClick={onMenuClick} />
            }
          />
          <Route
            path="/enforce-investigate/clear-advance-payment-onsite"
            element={<ClearAdvancePaymentInvestigate onClick={onMenuClick} />}
          />

          <Route
            path="/enforce-asset/main-select-enforce-asset"
            element={<MainSelectEnforceAsset onClick={onMenuClick} />}
          />
          <Route
            path="/enforce-asset/withdraw-advance-payment-enforce-asset"
            element={
              <WithdrawAdvancePaymentEnforceAsset onClick={onMenuClick} />
            }
          />
          <Route
            path="/enforce-asset/clear-advance-payment-enforce-asset"
            element={<ClearAdvancePaymentEnforceAsset onClick={onMenuClick} />}
          />
          <Route
            path="/asset-announcement/main-select-asset-announcement"
            element={<MainSelectAssetAnnouncement onClick={onMenuClick} />}
          />
          <Route
            path="/asset-announcement/asset-announcement-calendar"
            element={<SaleAnnouncementCalendar onClick={onMenuClick} />}
          />
          <Route
            path="/asset-average/main-select-asset-average"
            element={<MainSelectAssetAverage onClick={onMenuClick} />}
             />
          {/* รับเคสจาก CEO */}
          <Route
            path="/demand-guarantor/SentCEO"
            element={<MainSent90CEOToS4 onClick={onMenuClick} />}
          />
          <Route
            path="/letter-calendar/main"
            element={<MainLetterCalendars onClick={onMenuClick} />}
          />
          <Route
            path="/menu-manage-finance/report-contno-receive-payment"
            element={<MainContnoReceivePayment onClick={onMenuClick} />}
          />
          <Route
            path="/lost-contact-debts"
            element={<MainLostContactDebts onClick={onMenuClick} />}
          />
          <Route
            path="/enforce-investigate/enforce-investigate/select-contract-to-pre-enforce"
            element={<MainLostContactJudge onClick={onMenuClick} />}
          />
          <Route
            path="/enforce-investigate/main-assign-investigator-onsite-judge"
            element={<MainAssignInvestigatorOnsite onClick={onMenuClick} />}
          />
          <Route
            path="/main-doc-amc"
            element={<SendLawyerPage onClick={onMenuClick} />}
          />
          <Route
            path="/enforce-investigate/enforce-investigate/select-contract-to-enforce"
            element={<MainSelectToEnforce onClick={onMenuClick} />}
          />

          <Route
            path="/menu-acc/lost-contact-debts-acc"
            element={<MainLostContactDebtsAcc onClick={onMenuClick} />}
          />
          <Route
            path="/court/enforce-case-doc"
            element={<JudgeDocument onClick={onMenuClick} />}
          />
          <Route
            path="/load-judge-assets"
            element={<MainJudgeAssets onClick={onMenuClick} />}
          />
          <Route
            path="/enforce-investigate/enforce-investigate/contract-to-enforce"
            element={<MainContractToEnforce onClick={onMenuClick} />}
          />
          <Route
            path="/enforce/lawyer/main-enforce-doc"
            element={<MainEnforceDoc onClick={onMenuClick} />}
          />

          <Route
            path="/manage-contract-old/choose-contract-old"
            element={<MainOldContno onClick={onMenuClick} />}
          />

          <Route
            path="/menu-refinance"
            element={<MenuRefinance onClick={onMenuClick} />}
          />
          <Route
            path="/refinance/main-request-refinance"
            element={<MainRefinaceEnforce onClick={onMenuClick} />}
          />
          <Route
            path="/refinance/main-update-refinance"
            element={<MainRejudgementEnforce onClick={onMenuClick} />}
          />
          <Route
            path="/main-doc-amc-v2"
            element={<SendLawyerPageV2 onClick={onMenuClick} />}
          />

          <Route
            path="/menu-acc/report-pending-selling-car"
            element={<MainPendingSellingCar onClick={onMenuClick} />}
          />
          <Route
            path="/main-field-collection/contract-to-field-collection"
            element={<MainContractToFieldCollection onClick={onMenuClick} />}
          />
          <Route
            path="/enforce/field-collection/main-field-collection-doc"
            element={<MainFieldCollectionDoc onClick={onMenuClick} />}
          />
          <Route
            path="/menu-enforce"
            element={<MenuEnforce onClick={onMenuClick} />}
          />

          <Route
            path="/search/contarct-old-version"
            element={<ContractDetailMeeting onClick={onMenuClick} />}
          />
          <Route path="/report-lawyers-enforce" element={<EnforceReport />} />
          <Route
            path="/document-contno/report-income-stock"
            element={<MainReportIncomeStock />}
          />

          <Route
            path="/search/contarct-detail-new"
            element={<ContractDetailNew onClick={onMenuClick} />}
          />
          <Route
            path="/manage-contract/dashborad-lawyer-job-receiv"
            element={<DashboradLawyerJobReceiv onClick={onMenuClick} />}
          />
        </Routes>
      </AnimatePresence>
    </>
  );
}
